import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Field, Form } from 'react-final-form'
import {
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  MenuItem,
  Typography,
} from '@material-ui/core'
import IconBack from '@material-ui/icons/ArrowBack'
import { injectIntl } from 'react-intl'
import withPromise from 'helpers/withPromise'
import { Checkbox, Select } from 'components/common/FormInputs'
import Input from 'components/common/Form/Input'
import getValidator, {
  VALIDATOR_IS_EMPTY,
  VALIDATOR_IS_LESS_THEN_255_SYMBOLS,
} from 'validation'
import {
  fetchSiteGroupForm,
  setSiteGroupInfo,
  clearSiteGroupForm,
} from 'reducers/siteGroup/reducer'
import Loader from 'components/Loading'
import { REACT_INTL_PROP_TYPE } from 'constants/propTypes'
import messages from './translate'

class SiteGroupForm extends Component {
  componentDidMount() {
    const { fetchSiteGroupForm } = this.props

    fetchSiteGroupForm({
      entityId: this.getEntityId(),
    })
  }

  componentWillUnmount() {
    const { clearSiteGroupForm } = this.props

    clearSiteGroupForm()
  }

  getEntityId() {
    const {
      match: {
        params: { id },
      },
    } = this.props

    return id !== 'create' ? id : false
  }

  onSubmit = values => {
    const {
      setSiteGroupInfo,
      history: { goBack },
    } = this.props

    return withPromise(setSiteGroupInfo, {
      entityId: this.getEntityId(),
      values,
    }).then(errors => (errors ? Promise.resolve(errors) : goBack()))
  }

  getFormData = entity => {
    const formData = {
      name: '',
      sites: [],
      visibleInUi: true,
    }

    if (entity) {
      const { name, sites, visibleInUi } = entity
      formData.name = name
      formData.sites = sites.map(site => site.id)
      formData.visibleInUi = visibleInUi
    }

    return formData
  }

  render() {
    const {
      isLoadForm,
      formData,
      intl: { formatMessage },
      history: { goBack },
    } = this.props
    const { sites, siteGroup } = formData.toJS()
    const entityData = this.getFormData(siteGroup)

    if (isLoadForm) {
      return <Loader pastDelay />
    }

    return (
      <div className="container-fluid no-breadcrumb">
        <Typography variant="h5" className="headline">
          <IconButton size="medium" className="btn-back" onClick={goBack}>
            <IconBack fontSize="small" />
          </IconButton>
          {formatMessage(messages.siteGroupInfo)}
        </Typography>
        <Form
          onSubmit={this.onSubmit}
          initialValues={entityData}
          render={({ handleSubmit, submitting, pristine }) => (
            <form onSubmit={handleSubmit} className="form-basic">
              <Field
                name="name"
                type="text"
                label={formatMessage(messages.name)}
                component={Input}
                disabled={submitting}
                required
                validate={getValidator([
                  VALIDATOR_IS_EMPTY,
                  VALIDATOR_IS_LESS_THEN_255_SYMBOLS,
                ])}
              />
              <div className="form-group">
                <Field
                  multiple
                  name="sites"
                  component={Select}
                  label={formatMessage(messages.sites)}
                  disabled={submitting}
                  formControlProps={{
                    fullWidth: true,
                  }}>
                  {sites.map(({ id, name }) => (
                    <MenuItem button key={id} value={id}>
                      {name}
                    </MenuItem>
                  ))}
                </Field>
              </div>
              <FormControl fullWidth component="div" className="form-group">
                <FormControlLabel
                  label={formatMessage(messages.visibleInUi)}
                  disabled={submitting}
                  className="form-group"
                  control={
                    <Field
                      name="visibleInUi"
                      component={Checkbox}
                      type="checkbox"
                      color="primary"
                    />
                  }
                />
              </FormControl>
              <div className="form-group buttons">
                <Button
                  href={null}
                  type="submit"
                  color="primary"
                  size="medium"
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={submitting || pristine}>
                  {formatMessage(messages.saveInfo)}
                </Button>
              </div>
            </form>
          )}
        />
      </div>
    )
  }
}

SiteGroupForm.propTypes = {
  formData: PropTypes.object.isRequired,
  isLoadForm: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  intl: REACT_INTL_PROP_TYPE.isRequired,
  fetchSiteGroupForm: PropTypes.func,
  setSiteGroupInfo: PropTypes.func,
  clearSiteGroupForm: PropTypes.func,
}

SiteGroupForm.defaultProps = {
  fetchSiteGroupForm: () => {},
  setSiteGroupInfo: () => {},
  clearSiteGroupForm: () => {},
}

export default connect(
  state => ({
    isLoadForm: state.getIn(['siteGroup', 'isLoadForm']),
    formData: state.getIn(['siteGroup', 'formData']),
  }),
  {
    fetchSiteGroupForm,
    setSiteGroupInfo,
    clearSiteGroupForm,
  },
)(injectIntl(SiteGroupForm))
